// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/constant-speed-propeller-control.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/constant-speed-propeller-control/constant-speed-propeller-control.js';
import g1 from '../lessons/aeronautics/constant-speed-propeller-control/propeller-pitch.js';

mount([g0, g1]);
